import React from "react";
import {lowerCase, startCase, sortBy} from 'lodash';

/*

API:

DATA:
- Data is passed as a list of dictionaries. the default is to display all keys that don't start with a _
- You can modify this wit the "columns" prop, which must be the names of existing keys.
- Add _is_selected to an object to highlight the entire row
- if you want to customize the display, prepend the keys with _html_
        e.g., you have a key called 'city'. You could add the key _html_city to the dictionary to render
           <a href='google.com'>Los Angeles</a> in the table instead of the just the name.


ACTIONS
- default actions you add to every row of the table, generally to edit/whatever.
- passed in an array of dictionaries like:
 [
    {
        name: 'edit'
        elem: <Icon name='fa-pencil' onClick={() => doAction}/>
    }
 ]
 */
export default class BaseTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            sortable: this.props.sortable || true,
            sortKey: null,
            sortDesc: false,
        }
    }

    static defaultProps = {
        data: [],
        actions: [],
    };


    getSortedData = () => {
        let {sortKey} = this.state;
        let {data} = this.props;
        if (!(sortKey || data.length)) return data;

        // sort key is preceded by underscore if it exists;
        if (Object.keys(data[0]).includes('_' + sortKey)) {
            sortKey = '_' + sortKey;
        }
        let sortedData = sortBy(data, [sortKey]);
        return this.state.sortDesc ? sortedData.reverse() : sortedData;
    }


    toggleSortForColumn = column_name => {
        if (this.state.sortable) {
            if (this.state.sortKey === column_name) { // we are already sorting by this. Change to sort desc.
                if (!this.state.sortDesc) {
                    this.setState({sortDesc: true})
                } else { // third click turns sort off. We have already sorted desc.
                    this.setState({sortKey: null, sortDesc: false})
                }
            } else {
                this.setState({sortKey: column_name})
            }
        }
    }


    buildTableHeader = () => {
        let {data, actions} = this.props;
        if (!data.length) return;
        let headers = this.props.columns || Object.keys(data[0]).filter(d => d.charAt(0) !== '_');

        return (
            <thead>
                {!!actions && !!actions.length &&
                    <th style={{
                        opacity: 0
                    }}>--</th>
                }
                {headers.map(d => (
                        <th
                            className={`table header cursor-is-pointer ${this.state.sortKey === d ? 'sorted-table-header' : ''}`}
                            onClick={() => this.toggleSortForColumn(d)}
                        >{startCase(d)} {(this.state.sortable && this.state.sortKey === d) && (this.state.sortDesc ? '▲' : '▼')} </th>
                ))}
            </thead>
        )
    }


    buildTableRows = () => {
        let {data, actions} = this.props;
        if (!data.length) return;
        let headers = this.props.columns || Object.keys(data[0]).filter(d => d.charAt(0) !== '_');
        return (
            <tbody>
            {this.getSortedData().map((d, i, a) => (
                <tr className={d._is_selected ? 'is_selected' : ''} onClick={this.props.onRowClick ? () => this.props.onRowClick(d) : () => null}>
                    {/* First we add the default actions */}
                    {actions && !!actions.length &&
                        <td >
                            <span className="is-flex">
                                {actions.map(a => (
                                    <span className="table-action mx-3"
                                          onClick={() => a.action(d)}>{typeof a.elem === 'function' ? a.elem(d) : a.elem}</span>
                                ))}
                            </span>
                        </td>
                    }
                    {/* Add rows from the data. You can add a key to the data point with '_html_' prepended and it will display that first  */}
                    {headers.map(h => (
                        <td className={this.props.rowStyle}>{d['_html_' + h] || d[h]}</td>
                    ))}
                </tr>
            ))}

            </tbody>
        )
    }

    render() {
         return (
             <table className={'table ' + this.props.className}>
                 {this.buildTableHeader()}
                 {this.buildTableRows()}
             </table>
         )
    }

}


